export const MessagesBasic = `
<div>
  <Message
    icon="info"
    variant="primary"
    message="This is a primary message"
  ></Message>
  <Message
    icon={<i className="modus-icons" aria-hidden="true">help</i>}
    variant="secondary"
    message="This is a secondary message"
  ></Message>
</div>
`
